var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "waba-supsis-mm-lite-terms-signed" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("auto.whatsappBusinessApiV2MmLiteTermsSigned"))),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "meta" }, [
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.event")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.wabaId")))]),
        _vm._v(
          ": " + _vm._s(_vm.$_.get(_vm.activity, "payload.waba_info.waba_id"))
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.ownerBusinessId")))]),
        _vm._v(
          ": " +
            _vm._s(
              _vm.$_.get(_vm.activity, "payload.waba_info.owner_business_id")
            )
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("details", { staticClass: "raw" }, [
      _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
      _vm._v(" "),
      _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }